import * as React from 'react';

import ActivityIndicator from '~/UI/ActivityIndicator';

import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState, ThunkDispatch } from '~/Store';
import { fetchAccessTokenIfNeeded } from '../actions';
import { handleError } from '~/ErrorHandler';

const AccessTokenRequester = ({ children }: { children: React.ReactNode }) => {
	const dispatch = useDispatch<ThunkDispatch<any>>();
	const currentToken = useSelector(({ accessToken }: ApplicationState) => accessToken);

	React.useEffect(() => {
		if (!currentToken.isFetching && !currentToken.accessToken) {
			dispatch(fetchAccessTokenIfNeeded()).catch((error) => dispatch(handleError(error)));
		}
	}, []);

	return currentToken.accessToken ? <>{children}</> : <ActivityIndicator />;
};

export default React.memo(AccessTokenRequester);
